import React from 'react'
import { FocusSensor } from 'libreact/lib/FocusSensor'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'
import isDefault from './lib/isDefault'

const border = (props) => {
  if (props.readOnly) return props.theme.borders.darkerGrey6
  if (props.isFocused) return props.theme.borders.green3

  return props.theme.borders.grey6
}

const Container = styled.div`
  display: flex;
  padding: 5px 10px;
  border: ${border};
  background-color: ${props => props.readOnly ? props.theme.colors.darkerGrey14 : props.theme.colors.grey14};
  border-radius: 9999px;
  max-width: 100px;

  &:hover {
    border: ${props => props.isFocused ? props.theme.borders.green3 : props.theme.borders.grey5};
  }
`

const color = ({
  isDisabled,
  isDefault,
  theme: {
    colors: {
      grey,
      grey10,
      grey9,
    },
  },
}) => {
  if (isDisabled) return grey10
  if (isDefault) return grey9

  return grey
}

const Input = styled.input`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: ${props => props.readOnly ? 700 : 400};
  color: ${props => color(props)};
  background-color: ${props => props.readOnly ? props.theme.colors.darkerGrey14 : props.theme.colors.grey14};
`

const Prefix = styled.div`
  color: ${props => props.theme.colors.grey4};
`

const CustomInput = (props) => <Input {...props} />

export default ({
  disabled,
  onChange,
  onClick,
  bold,
  colorful,
  value,
  ...props,
}) => (
  <FocusSensor>
    {({ isFocused }) => (
      <Container
        onClick={onClick}
        isFocused={isFocused}
        {...props}
      >
        <Prefix>
          $
        </Prefix>
        <NumberFormat
          customInput={CustomInput}
          type='text'
          thousandSeparator
          value={value}
          onValueChange={({ value }) => (
            onChange({
              name: props.name,
              value,
            })
          )}
          isDisabled={disabled}
          isDefault={isDefault(props, value)}
          {...props}
        />
      </Container>
    )}
  </FocusSensor>
)
